import { render, staticRenderFns } from "./SfdcTable.vue?vue&type=template&id=bc10df20&scoped=true"
import script from "./SfdcTable.vue?vue&type=script&lang=js"
export * from "./SfdcTable.vue?vue&type=script&lang=js"
import style0 from "./SfdcTable.vue?vue&type=style&index=0&id=bc10df20&prod&lang=scss&scoped=true"
import style1 from "./SfdcTable.vue?vue&type=style&index=1&id=bc10df20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc10df20",
  null
  
)

export default component.exports